import image from "./error.gif";

function Error() {
  return (
    <>
      <center>
        <img src={image} alt='Loading' height={'200px'} width={'300px'}/>
      </center>
      <br></br>
    </>
  );
}

export default Error;
